// extracted by mini-css-extract-plugin
module.exports = {"container":"_34VFZCXIu_Brz0CgpNvvHw primaryBackgroundColor importantMessageTopBar","inner":"_2DMdNBePT6wYKroM-PEvpU"};